<template>
  <!-- 批量转交 -->
  <Modal
    :title="
      selectedCount === null
        ? $t('approval.transferApprovalAll')
        : $t('approval.transferApproval').replace('$1', selectedCount)
    "
    v-model="visible"
    :width="400"
    @on-cancel="onCancel"
  >
    <p>{{ $t('approval.transferTo') }}</p>
    <Select
      v-model="formData.forwardEmployeeId"
      filterable
      clearable
      remote
      :remote-method="remoteMethod"
      :loading="employeeSelectLoading"
      :not-found-text="$t('i.table.noDataText')"
      :placeholder="$t('approval.selectAnEmployee')"
      @on-clear="initEmployees"
    >
      <Option
        v-for="(item, index) in employees"
        :value="item.id"
        :disabled="item.id === $store.state.self.id"
        :label="item.fullName"
        :key="index"
      >
        {{ item.fullName }}
      </Option>
    </Select>
    <Row type="flex" align="middle" justify="end" :gutter="10" slot="footer">
      <Col>
        <Button @click="onCancel">
          {{ $t('btn.cancel') }}
        </Button>
      </Col>
      <Col>
        <Button
          type="primary"
          :disabled="!formData.forwardEmployeeId"
          :loading="submitLoading"
          @click="onOk"
        >
          {{ $t('approval.transfer') }}
        </Button>
      </Col>
    </Row>
  </Modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    selectedCount: {
      type: Number,
      default: null
    },
    isSearchClick: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: () => {}
    },
    searchAdvancedParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      submitLoading: false,
      formData: {
        forms: this.value,
        forwardEmployeeId: null,
        review: ''
      },
      employeeSelectLoading: false,
      employees: []
    };
  },
  methods: {
    show() {
      this.visible = true;
      this.initEmployees();
    },
    remoteMethod: _.debounce(function (query) {
      this.initEmployees(query);
    }, 300),
    async initEmployees(query) {
      try {
        this.employeeSelectLoading = true;
        const result = await this.$http(
          'get',
          'mobile/employees/select_list',
          {
            hasUser: true,
            include: 'OWNER_SHIP',
            search: query
          },
          true
        );
        this.employees = result.data.content;
        this.employeeSelectLoading = false;
      } catch (e) {
        console.log(e);
        this.employeeSelectLoading = false;
      }
    },
    onCancel() {
      this.visible = false;
      this.submitLoading = false;
      this.formData.forwardEmployeeId = null;
    },
    initSubmit() {
      let urlParams = '';
      // 有点击查询时
      if (this.isSearchClick) {
        const newFilters = _.cloneDeep(this.filters);
        // 选择“全部” tab，删除readFlag字段
        if ((this.active + '').toLocaleLowerCase() === 'all') {
          delete newFilters.readFlag;
        }
        delete newFilters.page;
        delete newFilters.size;
        _.forEach(newFilters, (_v, k) => {
          if (_.isNil(newFilters[k])) {
            _.unset(newFilters, k);
          }
        });
        urlParams = this.objToUrl(newFilters);
      }
      return {
        urlParams: urlParams,
        params: {
          forward: {
            forwardEmployeeId: this.formData.forwardEmployeeId
          },
          ...this.searchAdvancedParams
        }
      };
    },
    // 批量转交
    async onOk() {
      try {
        this.submitLoading = true;
        // 全选
        if (this.selectedCount === null) {
          const { urlParams, params } = this.initSubmit();
          await this.$http(
            'post',
            `mobile/forms/forward_batch_all${urlParams}`,
            params,
            true
          );
          this.$Message.success(this.$t('approval.forward_success'));
        } else {
          // 单选、多选
          const res = await this.$http(
            'post',
            'mobile/forms/forward_batch',
            this.formData,
            true
          );
          const { commitForms, hasForwards, deleteForms, otherError } =
            res.data;
          if (
            commitForms.length ||
            hasForwards.length ||
            deleteForms.length ||
            otherError.length
          ) {
            this.processingErrorMessage(res.data);
          } else {
            this.$Message.success(this.$t('approval.forward_success'));
          }
        }
        this.$emit('on-ok');
        this.onCancel();
      } catch (e) {
        this.submitLoading = false;
      }
    },
    objToUrl(obj) {
      const tempArray = [];
      for (const key in obj) {
        if (key && obj[key] !== null && obj[key] !== '') {
          tempArray.push(`${key}=${obj[key]}`);
        }
      }
      return `?${tempArray.join('&')}`;
    },
    processingErrorMessage(data) {
      const {
        commitForms,
        hasForwards,
        deleteForms,
        otherError,
        sucessForwards
      } = data;
      let tips = [];
      const newCommit = [...commitForms, ...hasForwards];
      if (newCommit.length) {
        //已处理的ID
        tips.push(
          this.$t('approval.hasProcessed').replace('$1', newCommit.join(','))
        );
      }
      if (deleteForms.length) {
        //已删除的ID
        tips.push(
          this.$t('approval.hasDeleted').replace('$1', deleteForms.join(','))
        );
      }
      if (otherError.length) {
        //其它错误的ID
        tips.push(
          this.$t('approval.otherErrorTips').replace('$1', otherError.join(','))
        );
      }
      if (sucessForwards.length) {
        // 成功的ID
        tips.push(this.$t('approval.haveSuccessOperation'));
      }
      this.$Modal.error({
        title: this.$t('team.tip'),
        content: tips.join('，')
      });
    }
  }
};
</script>
